<template>
    <div id="loginPage">
        <Carregamento v-if="!live" />
        <transition mode="out-in" v-else>
            <div class="containerAll">
                <Logo />
                <div v-if="novoAcesso == 1 && (live.login.config.loginWithCadastro=='true'|| live.login.config.onlyLogin=='true')" class="box-login pt-5">
                    <!-- <CenterLogo/> -->
                    <!-- <b-card> -->
                    <div class="container">
                      <!---  LOGIN  -->
                        <div class="row row-form">
                            <div class="col-lg-5 col-md-6 col-10  px-md-3 p-0 mx-auto mx-md-0">
                                <b-form @submit="onSubmit" v-if="show">

                                    <h1 class="h1 text-center text-white m-0" >{{txt.title}}</h1>
                                    <p class="p text-center text-white" >{{txt.caption}}</p>
                                    <!-- <p>¡Bienvenido! Ingrese su correo electrónico para acceder a la transmisión.</p> -->
                                    <b-alert v-if="alerta" show variant="danger">
                                       {{txt.errors[`${currentError}`]}}
                                       <!-- <br v-if="live.login.config.loginWithCadastro == 'true'" /><br v-if="live.login.config.loginWithCadastro == 'true'" />
                                        <c v-if="live.login.config.loginWithCadastro == 'true'">Não tem acesso? Clique <a @click.prevent="novoAcesso = 2"
                                            href="#">aqui</a> e solicite um!</c> -->
                                    </b-alert>

                                    <input type="text" class="form-control mb-2"  v-model="form.name" :placeholder="txt.inputName" required>

                                    <b-form-input id="password" class="form-control mb-2" v-model="form.email" type="text"
                                        :placeholder="txt.inputEmail" required>
                                    </b-form-input>

                                    <input type="text" class="form-control mb-2"  v-model="form.company" :placeholder="txt.inputCompany" required>

                                    <div class="text-center mb-4" style="position: relative; z-index:1000">
                                        <button :disabled="btnLogin.disabled" :style="btnStyles" class="btn myBtn w-100"
                                            type="submit">{{txt.btnTxt}}</button>
                                    </div>
                                    <div class="text-center " v-if="live.login.config.loginWithCadastro=='true'">
                                        <a class="sol-acesso text-white" @click.prevent="novoAcesso = 2" href="#">Solicitar acesso</a>
                                    </div>
                                </b-form>
                            </div>
                        </div>
                    </div>
                    <!-- </b-card> -->
                </div>

                <!---  EM BREVE   -->
<!--                <div>-->
<!--                    <div class="mx-auto" style="max-width: max-content; height: 90vh; display: flex; flex-direction: column; justify-content: center; box-sizing: border-box; padding-bottom: 50px;">-->
<!--                        &lt;!&ndash; <CenterLogo class="text-center mx-auto" /> &ndash;&gt;-->

<!--                        <p class="text-white text-center" style="font-size: 60px; line-height: 60px; font-weight: bold; filter: drop-shadow(0 0 10px rgba(0, 0, 0, .2));">-->
<!--                            EM BREVE-->
<!--                            <br>-->
<!--                            08/07 - 8h30-->
<!--                        </p>-->
<!--                    </div>-->
<!--                </div>-->
                <div class="box-login pt-5" v-else-if="novoAcesso == 2 || live.login.config.onlyCadastro=='true'">
                    <!-- <b-card> -->

                  <!-- EM BREVE -->
<!--                  <div class="container">-->
<!--                    <div class="row row-form justify-content-center align-items-center flex-column">-->
<!--                      <div class="col-12 col-sm-10 col-lg-6 px-md-3 d-flex justify-content-center align-items-center" style="gap: 30px">-->
<!--                        <img src="/logo.png" alt="Maquina dos Sonhos" class="img img-fluid d-none d-lg-block" style="max-width: 250px">-->
<!--                        <img src="/logo.png" alt="Maquina dos Sonhos" class="img img-fluid d-block d-lg-none" style="max-width: 150px">-->
<!--                        <img src="/selo.png" alt="Maquina dos Sonhos" class="img img-fluid d-none d-lg-block" style="max-width: 190px">-->
<!--                        <img src="/selo.png" alt="Maquina dos Sonhos" class="img img-fluid d-block d-lg-none" style="max-width: 150px">-->
<!--                      </div>-->
<!--                      &lt;!&ndash;                      <div class="col-12 col-sm-10 col-lg-6 px-md-3 ">&ndash;&gt;-->
<!--                      &lt;!&ndash;                        &lt;!&ndash; <div class="d-flex justify-content-center">&ndash;&gt;-->
<!--                      &lt;!&ndash;                            <CenterLogo/>&ndash;&gt;-->
<!--                      &lt;!&ndash;                        </div> &ndash;&gt;&ndash;&gt;-->
<!--                      &lt;!&ndash;                        <div class="boxLogin">&ndash;&gt;-->
<!--                      &lt;!&ndash;                          <h1 class="titleBox text-center m-0 mb-2" style="padding: 100px 0">EM BREVE</h1>&ndash;&gt;-->

<!--                      &lt;!&ndash;                        </div>&ndash;&gt;-->
<!--                      &lt;!&ndash;                      </div>&ndash;&gt;-->

<!--                      <div class="col-12 col-sm-10 col-lg-6 px-md-3 ">-->
<!--                        <p class="text-white text-center" style="font-size: 60px; line-height: 60px; font-weight: bold; filter: drop-shadow(0 0 10px rgba(0, 0, 0, .2));">-->
<!--                          <br>-->
<!--                          <br>-->
<!--                          EM BREVE-->
<!--                          <br>-->
<!--                        </p>-->

<!--                      </div>-->
<!--                    </div>-->
<!--                  </div>-->

<!--                   FORM-->
                  <div class="container">
                    <div class="row row-form justify-content-center align-items-center flex-column">
                      <div class="col-12 col-sm-10 col-lg-6 px-md-3 pb-4 d-flex justify-content-center align-items-center" style="gap: 30px">
                                                <img src="/logo.png" alt="Maquina dos Sonhos" class="img img-fluid d-none d-lg-block" style="max-width: 400px">
                                                <img src="/logo.png" alt="Maquina dos Sonhos" class="img img-fluid d-block d-lg-none" style="max-width: 150px">
                      </div>
<!--                      <div class="col-12 col-sm-10 col-lg-6 px-md-3 ">-->
<!--                        &lt;!&ndash; <div class="d-flex justify-content-center">-->
<!--                            <CenterLogo/>-->
<!--                        </div> &ndash;&gt;-->
<!--                        <div class="boxLogin">-->
<!--                          <h1 class="titleBox text-center m-0 mb-2" style="padding: 100px 0">EM BREVE</h1>-->

<!--                        </div>-->
<!--                      </div>-->

                      <div class="col-12 col-sm-10 col-lg-6 px-md-3 ">
                        <!-- <div class="d-flex justify-content-center">
                            <CenterLogo/>
                        </div> -->
                        <div class="boxLogin">
                          <h1 class="titleBox text-center m-0 mb-2">{{live.login.config.loginWithCadastro=='true' ? 'Novo acesso' : 'Login'}}</h1>
                          <p class="textBox text-center mb-3" >Preencha as informações para acessar a live.</p>
                          <b-form @submit="solicita">
                            <b-alert v-if="alertaSolicita.status" show :variant="alertaSolicita.variant">
                              {{alertaSolicita.msg}}
                            </b-alert>

                            <b-form-group id="nomeSolicita" class="mb-3" label-for="nomeSolicitaForm">
                              <b-form-input id="nomeSolicitaForm" v-model="formSolicita.name" type="text"
                                            placeholder="Nome" required>
                              </b-form-input>
                            </b-form-group>

                            <b-form-group id="nomeSolicita" class="mb-3" label-for="nomeSolicitaForm">
                              <b-form-input id="nomeSolicitaForm" v-model="formSolicita.surname" type="text"
                                            placeholder="Sobrenome" required>
                              </b-form-input>
                            </b-form-group>

                            <b-form-group id="emailSolicita" class="mb-3" label-for="emailSolicitaForm">
                              <b-form-input id="emailSolicitaForm" v-model="formSolicita.email" type="email"
                                            placeholder="E-mail corporativo" required>
                              </b-form-input>
                            </b-form-group>

                            <!-- <b-form-group id="telefoneSolicita" class="mb-2" label-for="telefoneSolicitaForm">
                                <b-form-input id="telefoneSolicitaForm" v-model="formSolicita.phone" type="text"
                                    placeholder="Seu Telefone" required>
                                </b-form-input>
                            </b-form-group> -->

                            <!-- <b-form-group id="empresaSolicita" class="mb-2" label-for="empresaSolicitaForm">
                                <b-form-input id="empresaSolicitaForm" v-model="formSolicita.company" type="text"
                                    placeholder="Empresa" required>
                                </b-form-input>
                            </b-form-group> -->

                            <b-input-group class="mb-3">
                              <b-form-select id="input-3" v-model="formSolicita.company" :options="distributors" required></b-form-select>
                              <template #append>
                                <div class="d-flex align-items-center aside">
                                  <b-icon icon="triangle-fill" aria-hidden="true"></b-icon>
                                </div>
                              </template>
                            </b-input-group>

                            <b-input-group>
                              <b-form-select id="input-3" v-model="formSolicita.office" :options="offices" required></b-form-select>
                              <template #append>
                                <div class="d-flex align-items-center aside">
                                  <b-icon icon="triangle-fill" aria-hidden="true"></b-icon>
                                </div>
                              </template>
                            </b-input-group>

                            <!-- <b-form-group id="indicouSolicita" label-for="indicouSolicitaForm" class="d-none">
                                <b-form-input id="indicouSolicitaForm" v-model="formSolicita.indication" type="text"
                                    placeholder="Quem indicou" required>
                                </b-form-input>
                            </b-form-group> -->

                            <div class="d-flex justify-content-center">
                              <button v-if="live.login.config.loginWithCadastro=='true'" :style="btnStyles" class="btn w-45 myBtn" type="button" @click.prevent="novoAcesso = 1">Voltar</button>
                              <button id="btnSolicita" :disabled="btnSolicita.disabled" :style="btnStyles" class="btn w-45 myBtn mt-3"
                                      type="submit">{{btnSolicita.message}}</button>
                            </div>

                          </b-form>
                        </div>
                      </div>
                    </div>
                  </div>

                </div>
                <div v-else-if="novoAcesso == 3" class="box-login">
                    <b-card>
                        <h1>{{telaFinal.h1}}</h1>
                        <p>{{telaFinal.p}}</p>
                        <div class="text-center">
                            <button :style="btnStyles" class="btn" type="button" @click.prevent="novoAcesso = 2">Voltar</button>
                        </div>
                    </b-card>
                </div>
                <div v-else-if="novoAcesso == 4" class="box-login">
                    <b-card>
                        <h1>{{telaFinal.h1}}</h1>
                        <p>{{telaFinal.p}}</p>
                        <!-- {{novoAcesso}} -->
                        <div class="text-center">
                            <button v-if="live.login.config.loginWithCadastro=='true'" :style="btnStyles" class="btn" type="button" @click.prevent="novoAcesso = 1">Voltar a tela inicial</button>
                            <button v-else :style="btnStyles" class="btn" type="button" @click.prevent="novoAcesso = 2">Voltar a tela inicial</button>
                        </div>
                    </b-card>
                </div>
            </div>

        </transition>
        <!-- <LogoBottom :margin="80"/> -->
        <Footer :lang="lang"/>
    </div>
</template>

<script>
    /* global grecaptcha */
    import {
        api
    } from "@/services.js";
    import {
        mapState
    } from 'vuex';
    import Logo from '@/components/Login/Logo.vue';
    // import CenterLogo from '@/components/Login/CenterLogo.vue';
    import Footer from '@/components/Login/Footer.vue';
    // import LogoBottom from '@/components/Login/LogoBottom.vue';

    export default {
        props: ['password','lang'],
        name: "login",
        components: {
            // CenterLogo,
            Logo,
            Footer
            // LogoBottom
        },
        data() {
            return {
                currentError:null,
                form: {
                    email: this.password
                },
                formSolicita: {
                    name: "",
                    surname: "",
                    email: "",
                    phone: "",
                    company: null,
                    office: null,
                    indication: ""
                },
                btnSolicita: {
                    message: '',
                    disabled: false
                },
                telaFinal: {
                    h1: null,
                    p: null
                },
                show: true,
                btnStyles: {},
                retryCount: 0,
                btnLogin: {
                    message: "ENTRAR",
                    // MUDAR AQUIIII
                    disabled: false,
                    btn: null
                },
                alerta: false,
                novoAcesso: 1,
                alertaSolicita: {
                    status: false,
                    msg: '',
                    variant: ''
                },
                txt: {
                    title: '',
                    caption: '',
                    inputName: '',
                    inputEmail: '',
                    btn: '',
                    btnTxt: '',
                    btnSend: '',
                    alert: ''
                },
                distributors: [],
                offices: [],
            }
        },
        computed: {
            ...mapState(['live'])
        },
        methods: {
            redirectToWaiting(){
                if(this.$route.params.lang == "en"){
                    this.$router.push(`/${this.lang}`)

                } else if(this.live.waiting[`${this.lang}`] == 'true' || this.live.waiting[`${this.lang}`]){
                    this.$router.push(`/waiting/${this.lang}`)
                }else if(this.live.login.config.state=='public') {
                    this.$router.push(`live/${this.lang}`)
                }
            },
            onSubmit(event) {
                if(this.live.login.config.onlyCadastro=='false') {
                    event.preventDefault()
                    this.btnLogin.disabled = true;
                    this.txt.btnTxt = this.txt.btnSend;
                    this.alerta = false;
                }
                else {
                    // this.alertaSolicita.status = false;
                    this.btnSolicita.disabled = true;
                    this.btnSolicita.message = 'Entrando'
                }

                this.form.liveId = this.$store.state.live.id
                this.form.lang = this.lang
                this.form.originBy = 'Login'
                this.form.email = this.formSolicita.email

                api.login(this.form).then(res => {
                    this.currentError = `error${parseInt(res.data.code)}`
                    // this.resetRecaptcha()

                    switch(parseInt(res.data.code)) {
                        case 1:
                            this.$store.commit("UPDATE_ID_USER", res.data.userId);
                            window.localStorage.token = res.data.userId
                            window.localStorage.mail = this.form.email
                            this.$store.commit("UPDATE_LOGIN", true);
                            if(this.lang=='pt') {
                                this.$gtag.event('Login made in pt', { method: 'Google' })
                            }else if(this.lang=='esp') {
                                this.$gtag.event('Login made in esp', { method: 'Google' })
                            }else {
                                this.$gtag.event('Login made in other', { method: 'Google' })
                            }
                            this.$router.push(`/live/${this.live.id}/${this.lang}`);
                        break;
                        case 2:
                            this.btnLogin.disabled = true;
                            this.txt.btnTxt = this.txt.btn;
                            this.alerta = true;
                            this.$gtag.event('Login failed - domain not allowed', { method: 'Google' })
                        break;
                        case 3:
                            this.solicita()
                        break;
                        case 4:
                            this.btnLogin.disabled = true;
                            this.txt.btnTxt = this.txt.btn;
                            this.alerta = true;
                        break;
                        case 5:
                            this.btnLogin.disabled = true;
                            this.txt.btnTxt = this.txt.btn;
                            this.alerta = true;
                        break;
                        case 6:
                            this.btnLogin.disabled = true;
                            this.txt.btnTxt = this.txt.btn;
                            this.alerta = true;
                        break;
                        case 7:
                            this.btnLogin.disabled = true;
                            this.txt.btnTxt = this.txt.btn;
                            this.alerta = true;
                        break;
                        case 8:
                            this.btnLogin.disabled = true;
                            this.txt.btnTxt = this.txt.btn;
                            this.alerta = true;
                        break;
                        case 9:
                            this.btnLogin.disabled = true;
                            this.txt.btnTxt = this.txt.btn;
                            this.alerta = true;
                        break;
                        case 10:
                            this.alertaSolicita.msg = 'Por favor complete el recaptcha'
                            this.alertaSolicita.variant = 'warning'
                            this.alertaSolicita.status = true
                        break;
                    }

                    // console.log(response.data)
                    // if(response.data.id){
                    //     window.localStorage.id_User = response.data.id
                    //     this.$store.commit("UPDATE_ID_USER", response.data.id);
                    // }
                    // if (!response.data.token) {
                    //     if(this.live.login.config.onlyCadastro=='false') {
                    //         this.btnLogin.disabled = false;
                    //         this.txt.btnTxt = this.txt.btn;
                    //         this.alerta = true;
                    //     }else {
                    //         this.btnSolicita.disabled = false;
                    //         this.txt.btnTxt = this.txt.btn;
                    //         this.alertaSolicita = true;
                    //     }
                    // } else {
                    //     window.localStorage.token = response.data.token
                    //     this.$store.commit("UPDATE_LOGIN", true);
                    //     this.$router.push(`/live/${this.live.id}/${this.lang}`);
                    // }
                    // this.$router.push(`/live/${this.live.id}/${this.lang}`);
                });

            },
            async solicita(event) {
                if (event) event.preventDefault()

                this.btnSolicita.disabled = true;
                this.live.login.config.loginWithCadastro=='true' ? this.btnSolicita.message = 'Envío' : this.btnSolicita.message = 'Entrando'

                await new Promise((resolve) => grecaptcha.ready(resolve));
                const recaptchaToken = await grecaptcha.execute('6LeSfnIsAAAAAIL2TGrAbIlo1NhiYb0PBINvhnfU', { action: 'submit' });
                this.formSolicita['g-recaptcha-response'] = recaptchaToken;

                this.formSolicita.config = this.live.login.config
                this.formSolicita.liveId = this.live.id
                await api.solicitation(this.formSolicita).then(response => {

                    //usuario já cadastrado
                    if (response.data.code == 102) {
                        this.telaFinal.h1 = 'E-mail já cadastrado!';
                        this.telaFinal.p = 'Esse email já conta em nossos cadastros.';
                        this.telaFinal.btn = true;
                        this.novoAcesso = 3;

                        //cadastrado com sucesso
                    } else if (response.data.code == 100) {
                        this.telaFinal.h1 = 'Solicitação envidada!';
                        this.telaFinal.p = 'Em breve você irá receber um e-mail com os dados de acesso!';
                        this.novoAcesso = 4;


                        //El registro falló
                    } else if (response.data.code == 101) {
                        this.telaFinal.h1 = 'El registro falló';
                        this.telaFinal.p = 'Algo salió mal. Inténtalo de nuevo';
                        this.telaFinal.btn = true;
                        this.novoAcesso = 4;

                        // Cadastro retornando a senha
                    } else if(response.data.code == 103 || response.data.code == 105 ){
                        this.alertaSolicita.msg = 'Carregando...'
                        this.alertaSolicita.variant = 'success'
                        this.alertaSolicita.status = true
                        this.form.password = response.data.token
                        this.retryCount = 3;
                        this.onSubmit();

                        //erro 500
                    }else if(response.data.code == 10) {
                        this.alertaSolicita.msg = 'Por favor complete el recaptcha'
                        this.alertaSolicita.variant = 'warning'
                        this.alertaSolicita.status = true
                    }else {
                        this.telaFinal.h1 = 'El registro falló';
                        this.telaFinal.p = 'Algo salió mal. Inténtalo de nuevo';
                        this.telaFinal.btn = true;
                        this.novoAcesso = 4;
                    }


                    this.live.login.config.loginWithCadastro=='true' ? this.btnSolicita.message = 'Solicitar' : this.btnSolicita.message = 'ENTRAR'


                });

            },
            setStyle() {
                let obj = this.$store.state.live;
                let prefix = obj.login;

                switch (this.lang) {
                    case 'pt':
                        this.txt.title = prefix.texts.pt.title
                        this.txt.caption = prefix.texts.pt.caption
                        this.txt.inputName = prefix.texts.pt.inputName
                        this.txt.inputEmail = prefix.texts.pt.inputEmail
                        this.txt.inputCompany = prefix.texts.pt.inputCompany
                        this.txt.inputOffice = prefix.texts.pt.inputOffice
                        this.txt.btn = prefix.texts.pt.btn
                        this.txt.btnSend = prefix.texts.pt.btnSend
                        this.txt.alert = prefix.texts.pt.alert
                        this.txt.errors = prefix.texts.pt.errors

                        this.txt.btnTxt = this.txt.btn
                        break;
                    case 'esp':
                        this.txt.title = prefix.texts.esp.title
                        this.txt.caption = prefix.texts.esp.caption
                        this.txt.inputName = prefix.texts.esp.inputName
                        this.txt.inputEmail = prefix.texts.esp.inputEmail
                        this.txt.inputCompany = prefix.texts.esp.inputCompany
                        this.txt.inputOffice = prefix.texts.esp.inputOffice
                        this.txt.btn = prefix.texts.esp.btn
                        this.txt.btnSend = prefix.texts.esp.btnSend
                        this.txt.alert = prefix.texts.esp.alert
                        this.txt.errors = prefix.texts.esp.errors

                        this.txt.btnTxt = this.txt.btn
                        break;
                    case 'en':
                        this.txt.title = prefix.texts.en.title
                        this.txt.caption = prefix.texts.en.caption
                        this.txt.inputName = prefix.texts.en.inputName
                        this.txt.inputEmail = prefix.texts.en.inputEmail
                        this.txt.btn = prefix.texts.en.btn
                        this.txt.btnSend = prefix.texts.en.btnSend
                        this.txt.alert = prefix.texts.en.alert

                        this.txt.btnTxt = this.txt.btn
                        break;
                    default:
                        this.txt.title = prefix.texts.pt.title
                        this.txt.caption = prefix.texts.pt.caption
                        this.txt.inputName = prefix.texts.pt.inputName
                        this.txt.inputEmail = prefix.texts.pt.inputEmail
                        this.txt.btn = prefix.texts.pt.btn
                        this.txt.btnSend = prefix.texts.pt.btnSend
                        this.txt.alert = prefix.texts.pt.alert

                        this.txt.btnTxt = this.txt.btn
                        break;
                }

                obj.login.config.loginWithCadastro=='true' ? this.btnSolicita.message = 'Solicitar' : this.btnSolicita.message = 'ENTRAR'
                // document.body.style.cssText =`background: url(${prefix.body.styles.backgroundImage}) ${prefix.body.styles.backgroundColor}`;
                document.body.style.cssText =`background: url(${require('../assets/img/background.png')}) ${prefix.body.styles.backgroundColor}`;

                this.btnStyles = prefix.button;

                var distWithSelect = [{text:'Distribuidor Licenciado',value:null},...prefix.distributors]
                var officesWithSelect = [{text:'Cargo',value:null},...prefix.offices]

                this.distributors = distWithSelect ?? []
                this.offices = officesWithSelect ?? []

            },
            getLive() {
                this.$store
                    .dispatch('getLive', this.lang)
                    .then(() => {
                        if(this.live.login.config.state == 'public' && this.live.waiting[`${this.lang}`]!='true') {
                            this.$router.push(`/live/${this.lang}`)
                        }
                        // else if(this.live.waiting == 'true') {
                        //     this.$router.push('/waiting')
                        // }
                        this.setStyle();
                    })
                    .catch(error => {
                        console.log(error);
                    })
            },
            setLang(){
                this.$route.params.lang ? this.$store.commit('UPDATE_LANG', this.$route.params.lang) : this.$store.commit('UPDATE_LANG', 'pt')
            }
        },
        watch: {
            live(){
                this.redirectToWaiting();
            },
            lang() {
                this.setLang()
                this.getLive()
            }
        },
        created() {
            this.setLang()
            this.getLive()
        }
    }
</script>


<style scoped>
.box-login{
    //height: calc(100vh - (3rem + 49px));
    display: flex;
    align-items: center;
}
@media(max-width: 991px){
    .box-login{
        height: auto;

    }
    .box-login .row-form > div{
        margin: 100px auto 0 auto !important;
    }
}
@media(max-width: 768px){
    .box-login .row-form > div{
        margin: 50px auto 0 auto !important;
    }
}

#loginPage{
    /*background-image: url("../assets/img/tickets.png");*/
    /*background-repeat: no-repeat;*/
    /*background-size: cover;*/
    /*background-position: top;*/
}

.h1{
    font-family: 'museo-sans-900';
    font-size: 75px;
}
.row-form{
    /* padding: 100px 0; */
}
.p{
    font-family: 'museo-sans';
    font-size: 23px;
}

input, select{
    font-family: 'museo-sans';
    border: 1px solid #A2A2A2;
    border-radius: 10px;
    background: #F5F5F5;
}
input:focus, select:focus{
    border-color: #1EA69B;
    box-shadow: none;
}

select {
    border-right: 0;
}
.myBtn{
    border: none;
    border-radius: 10px;
    background: #569992;
    font-family: 'museo-sans-900';
    text-transform: uppercase;
    padding: 10px 15px;
}
.w-45{
    width: 45%;
}
@media(max-width: 1200px){
    .h1{font-size: 63px;}
    .p{font-size: 19px;}
}
@media(max-width: 991px){
    .h1{font-size: 56px;}
    .p{font-size: 17px;}
    input{ border-radius: 8px;}
    .myBtn{border-radius: 8px;}
}
@media(max-width: 767px){
    /* .row-form{padding: 100px 0 50px 0;} */
    .p{
        font-size: 15px;
        width: 200px;
        margin-left: auto;
        margin-right: auto;
    }

  .container{
    padding-top: 80px;
  }
}

@media(max-width: 428px){
    .h1{font-size: 44px;}
}

    .textLogin, .textDesc {
        color: #00A184;
        font-weight: 700;
    }

    .lineFru {
        background: #00A184;
        border-radius: 32px;
        width: 150px;
        height: 10px;
        transform: skewX(-25deg);
    }

    /* input:not(input[type="submit"]) {
        border: 2px solid #00A184;
    } */
    .containerAll {
        min-height: calc(100vh - 88px);
    }

    @media(max-width:767px) {
        .containerAll {
            min-height: calc(100vh - 108px);
        }
    }

    @media(max-width:423px) {
        .containerAll {
            min-height: calc(100vh - 72.2px);
        }
    }

    .titleBox, .textBox {
        color: #1EA69B;
    }

    .titleBox {
        font-family: 'museo-sans-900';
    }

    .textBox {
        font-family: 'museo-sans';
    }

    .boxLogin {
        background: #FFFFFF;
        padding: 50px;
        border-radius: 18px;
        border: 1px solid #1EA69B;
    }

    @media(max-width:575px) {
    .row-form{padding: 0 0 50px 0;}
    .boxLogin {
        padding: 30px 15px;
    }
}

.aside {
    background: #F5F5F5;
    border: 1px solid #A2A2A2;
    padding: 0 10px;
    border-radius: 0 10px 10px 0px;
}

.aside svg {
    transform: rotate(180deg);
    width: 10px;
    color: #8a8a8a;
}
</style>